// @format
import React, { Component } from 'react';
import { createBrowserHistory } from 'history';
import { Router, Switch, Route } from 'react-router-dom';
import Landing from './components/Landing';
import ViewerGeneric from './components/ViewerGeneric';
import ViewerEnrollment from './components/ViewerEnrollment';
import ViewerTrust from './components/ViewerTrust';

export const history = createBrowserHistory();

class App extends Component {
  render() {
    return (
      <Router history={history}>
        <Switch>
          <Route exact path="/view/enrollment" component={ViewerEnrollment} />
          <Route exact path="/view/trust" component={ViewerTrust} />
          <Route exact path="/view" component={ViewerGeneric} />
          <Route exact path="/" component={Landing} />
        </Switch>
      </Router>
    );
  }
}

export default App;
